// import { Typogaphy } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import SubHeaders from '@/components/Headers/SubHeaders'
import { paths } from '@/utils/path'
import NavigationCards from '../NavigationCards'
import ComingSoon from '@/components/ComingSoon'

const Contracts = () => {
    const { t } = useTranslation()

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    { path: paths.account, title: t('account') },
                    { path: '', title: t('contracts') },
                ]}
            />

            <NavigationCards>
                <ComingSoon
                    featureName="contracts"
                    description="contract-management-coming-soon"
                    showBackButton={false}
                />
                {/* <div className="space-y-4">
                    <div className="rounded-lg border border-[#ECEFF1] p-4">
                        <Typogaphy size="medium" className="font-semibold mb-3">
                            {t('Hợp đồng hiện tại')}
                        </Typogaphy>
                        <Typogaphy size="small" className="text-gray-600">
                            {t('Thông tin hợp đồng lao động đang có hiệu lực')}
                        </Typogaphy>
                    </div>

                    <div className="rounded-lg border border-[#ECEFF1] p-4">
                        <Typogaphy size="medium" className="font-semibold mb-3">
                            {t('Lịch sử hợp đồng')}
                        </Typogaphy>
                        <Typogaphy size="small" className="text-gray-600">
                            {t('Danh sách các hợp đồng đã ký kết')}
                        </Typogaphy>
                    </div>

                    <div className="rounded-lg border border-[#ECEFF1] p-4">
                        <Typogaphy size="medium" className="font-semibold mb-3">
                            {t('Phụ lục hợp đồng')}
                        </Typogaphy>
                        <Typogaphy size="small" className="text-gray-600">
                            {t('Các phụ lục và điều khoản bổ sung')}
                        </Typogaphy>
                    </div>
                </div> */}
            </NavigationCards>
        </div>
    )
}

export default Contracts
